import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import "../../assets/css/sass/affiliate.scss";

const NavItem = ({ to, icon, label, active }) => (
  <Link to={to} className={`nav-item ${active ? "active" : ""}`}>
    {icon}
    <span>{label}</span>
    {active && <div className="active-indicator"></div>}
  </Link>
);

const AffiliateLayout = ({ children, history }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = localStorage.getItem("affiliate_user");
    if (userData) {
      setUser(JSON.parse(userData));
    } else {
      history.push("/login");
    }
  }, [history]);

  const handleLogout = () => {
    localStorage.removeItem("affiliate_token");
    localStorage.removeItem("affiliate_user");
    history.push("/login");
  };

  const isActive = (path) => history.location.pathname.includes(path);

  const getTitle = () => {
    const { pathname } = history.location;
    if (pathname.includes("/dashboard")) return "Tổng quan";
    if (pathname.includes("/campaigns")) return "Chiến dịch";
    if (pathname.includes("/customers")) return "Khách hàng giới thiệu";
    if (pathname.includes("/marketing-kit")) return "Marketing Kit";
    if (pathname.includes("/payouts")) return "Yêu cầu rút tiền";
    if (pathname.includes("/commissions")) return "Hoa hồng";
    if (pathname.includes("/settings")) return "Cài đặt tài khoản";
    return "Dashboard";
  };

  return (
    <div className="aff-layout">
      {/* Sidebar */}
      <aside className="aff-sidebar">
        <div className="aff-sidebar-header">
          <img
            src="/assets/img/logo-horizontal.svg"
            alt="VMASS Partner"
            style={{ height: "36px", marginTop: "8px" }}
          />
          <span className="brand-suffix">Partner</span>
        </div>

        <nav className="aff-sidebar-nav">
          <NavItem
            to="/dashboard"
            active={isActive("dashboard")}
            label="Tổng quan"
            icon={
              <svg
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                />
              </svg>
            }
          />
          <NavItem
            to="/campaigns"
            active={isActive("campaigns")}
            label="Chiến dịch"
            icon={
              <svg
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6 3 3 0 000 6zM5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z"
                />
              </svg>
            }
          />
          <NavItem
            to="/customers"
            active={isActive("customers")}
            label="Khách hàng"
            icon={
              <svg
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
            }
          />
          <NavItem
            to="/commissions"
            active={isActive("commissions")}
            label="Hoa hồng"
            icon={
              <svg
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            }
          />
          <NavItem
            to="/payouts"
            active={isActive("payouts")}
            label="Rút tiền"
            icon={
              <svg
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                />
              </svg>
            }
          />
          <NavItem
            to="/marketing-kit"
            active={isActive("marketing-kit")}
            label="Marketing Kit"
            icon={
              <svg
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                />
              </svg>
            }
          >
            <span className="badge-new">NEW</span>
          </NavItem>
          <NavItem
            to="/settings"
            active={isActive("settings")}
            label="Cài đặt"
            icon={
              <svg
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            }
          />
        </nav>

        <div className="aff-sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">{user?.name?.charAt(0) || "A"}</div>
            <div className="user-details">
              <p className="name">{user?.name}</p>
              <p className="email">{user?.email}</p>
            </div>
          </div>
          <button onClick={handleLogout} className="logout-btn">
            <svg
              width="14"
              height="14"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
              />
            </svg>
            Đăng xuất
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="aff-main">
        <header className="aff-header">
          <h2 className="page-title">{getTitle()}</h2>
          <div className="header-actions">
            <div className="system-status">
              <div className="dot"></div>
              <span>Hệ thống hoạt động</span>
            </div>
            <div className="divider"></div>
            <div className="balance-info">
              <span className="label">Số dư khả dụng</span>
              <span className="amount">
                {(Number(user?.balance) || 0).toLocaleString()}
                <span className="currency">VNĐ</span>
              </span>
            </div>
          </div>
        </header>

        <div className="aff-content">{children}</div>
      </div>
    </div>
  );
};

export default withRouter(AffiliateLayout);
